const versionAuth = {
	site_general_profile: true,
	site_product_group: true,
	site_device_printer: true,
	site_user_account: true,
	site_product_category: true,
	site_product_overview: true,
	site_product_table_set_overview: true,
	site_device_machine: true,
	site_product_option_set: true,
};

export default versionAuth;
